import {Injectable} from "@angular/core";
import {ScriptStore} from "./script.store";

declare var document: any;

@Injectable({
    providedIn: 'root'  //Check me
})
export class ScriptService {

    private scripts: any = {};

    constructor() {
        ScriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });
    }

    load(...scripts: string[]) {
        var promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }

    loadScript(name: string) {
        return new Promise((resolve, reject) => {
            //resolve if already loaded
            if (this.scripts[name].loaded) {
                resolve({script: name, loaded: true, status: 'Already Loaded'});
            }
            else {
                //load script
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.scripts[name].src;
                script.id = name;
                if (script.readyState) {  //IE
                    script.onreadystatechange = () => {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            this.scripts[name].loaded = true;
                            resolve({script: name, loaded: true, status: 'Loaded'});
                        }
                    };
                } else {  //Others
                    script.onload = () => {
                        this.scripts[name].loaded = true;
                        resolve({script: name, loaded: true, status: 'Loaded'});
                    };
                }
                script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }


    

    remove(...scripts: string[]) {
        var promises: any[] = [];
        scripts.forEach((script) => promises.push(this.removeScript(script)));
        return Promise.all(promises);
    }

    removeScript(name: string) {
        return new Promise((resolve, reject) => {
            //resolve if already loaded
            if (this.scripts[name].loaded) {
                //remove script

                try{
                    var tagGTMLocal = document.getElementById("gtm");
                    tagGTMLocal.parentElement.removeChild(tagGTMLocal);
                }
                catch(error){
                    console.log("Error removing gtm");
                }
                
                

                try{
                    var tagGTM = document.getElementById("googletagmanager");
                    tagGTM.parentElement.removeChild(tagGTM);

                }catch(error){
                    console.log("Error removing googletagmanager");

                }

            }
            this.scripts[name].loaded = false;
            resolve({script: name, loaded: false, status: 'Script removed'});
        });
    }

    removeBySrc(...sources: string[]){
        var promises: any[] = [];
        sources.forEach((eachSrc) => promises.push(this.removeScriptBySrc(eachSrc)));
        return Promise.all(promises);
    }


    removeScriptBySrc(eachSrc: string) {
        return new Promise((resolve, reject) => {
            
            try{
                var allScripts = document.getElementsByTagName("script");
                for (var i = 0; i < allScripts.length; ++i) {
                    
                    var attrSrc = allScripts[i].getAttribute('src');

                    console.log("sources " + attrSrc);
                    if( attrSrc.includes(eachSrc)){

                      console.log("Removing script:" + attrSrc);
                      var me = allScripts[i];
                      me.parentElement.removeChild(me);
                    }
                }
            }
            catch(error){
                console.log("Error removing by src:" + eachSrc);
            }
            resolve({script: name, status: 'Script removed by src' + eachSrc});
        });
    }
    
}